/**
 * POS-I123: one place that decides how a saved cart line (a browser draft or a held order) gets its
 * line discount back. The amount is NOT trusted from the saved copy: the type and value are handed to
 * the cart store (`setItemDiscount`), which re-prices through `computeLineDiscountAmount`.
 * A draft saved before POS-I119 has no discount fields and simply restores without a discount.
 */
import type { LineDiscountType } from '@/lib/line-discount';

export interface SavedLineDiscountFields {
  discountType?: string | null;
  discountValue?: number | string | null;
  discountReason?: string | null;
  discountApprovedById?: string | null;
}

export interface RestoredLineDiscount {
  type: LineDiscountType;
  value: number;
  meta: { reason?: string; approvedById?: string };
}

export function restoredLineDiscount(item: SavedLineDiscountFields | null | undefined): RestoredLineDiscount | null {
  if (!item) return null;
  const type = item.discountType;
  if (type !== 'FIXED' && type !== 'PERCENTAGE') return null;
  const value = Number(item.discountValue);
  if (!Number.isFinite(value) || value <= 0) return null;
  return {
    type,
    value,
    meta: {
      reason: item.discountReason || undefined,
      approvedById: item.discountApprovedById || undefined,
    },
  };
}
